export const HOUR_HEIGHT = 48
export const TOTAL_HEIGHT = HOUR_HEIGHT * 24
export const MINUTES_PER_DAY = 24 * 60
export const SNAP_MINUTES = 15
export const DEFAULT_DURATION_MIN = 60

export function clampMinute(minute: number): number {
  return Math.max(0, Math.min(MINUTES_PER_DAY, minute))
}

export function snapMinute(minute: number): number {
  return clampMinute(Math.round(minute / SNAP_MINUTES) * SNAP_MINUTES)
}

export function minuteToY(minute: number): number {
  return (minute / 60) * HOUR_HEIGHT
}

export function yToMinute(y: number): number {
  return clampMinute((y / HOUR_HEIGHT) * 60)
}

export function formatMinute(minute: number): string {
  const m = clampMinute(minute)
  const h = Math.floor(m / 60)
  const mm = m % 60
  return `${String(h).padStart(2, '0')}:${String(mm).padStart(2, '0')}`
}

export function parseTime(s: string): number | null {
  const match = /^(\d{1,2}):(\d{2})$/.exec(s.trim())
  if (!match) return null
  const h = Number(match[1])
  const m = Number(match[2])
  if (Number.isNaN(h) || Number.isNaN(m)) return null
  if (h < 0 || h > 24 || m < 0 || m >= 60) return null
  if (h === 24 && m !== 0) return null
  return h * 60 + m
}
